// Fullscreen is only nice to have: if the browser refuses, or the call fails in any other
// way, the page goes on as it is, and nothing is shown or reported.

function isFullscreen() {
    return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
    );
}

// Calls the first of `names` that `obj` has, and ignores any failure, also from the
// promise that the standard methods return.
function callFirst(obj, names) {
    try {
        for (let i = 0; i < names.length; i++) {
            if (obj[names[i]]) {
                const result = obj[names[i]]();
                if (result && result.catch) result.catch(() => {});
                return;
            }
        }
    } catch (e) {
        // nothing to do
    }
}

// Enters fullscreen mode, unless the page is in it already. Browsers only allow this in
// response to a user event such as a click.
export function openFullscreen() {
    if (isFullscreen()) return;
    callFirst(document.documentElement, [
        "requestFullscreen",
        "webkitRequestFullscreen", // older Safari
        "mozRequestFullScreen", // older Firefox
        "msRequestFullscreen", // IE/Edge
    ]);
}

// Leaves fullscreen mode, if the page is in it. Exiting needs no user gesture.
export function closeFullscreen() {
    if (!isFullscreen()) return;
    callFirst(document, [
        "exitFullscreen",
        "webkitExitFullscreen", // older Safari
        "mozCancelFullScreen", // older Firefox
        "msExitFullscreen", // IE/Edge
    ]);
}
